import { render } from "./BarcodeScannerModal.vue?vue&type=template&id=746165d3&scoped=true"
import script from "./BarcodeScannerModal.vue?vue&type=script&lang=js"
export * from "./BarcodeScannerModal.vue?vue&type=script&lang=js"

import "./BarcodeScannerModal.vue?vue&type=style&index=0&id=746165d3&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746165d3"]])

export default __exports__